import './styles/index.css';

import React from 'react';
import ReactDOM from 'react-dom';

import App from './modules/App';
import registerServiceWorker from './registerServiceWorker';

/** redux */
import { Provider } from 'react-redux';
import configureStore from './store';
import rootSaga from './sagas';

/** router v4 */
import { Router } from 'react-router-dom';
import history from './history';

const store = configureStore();
store.runSaga(rootSaga);

ReactDOM.render(
  <Router history={history}>
    <Provider store={store}>
      <App />
    </Provider>
  </Router>,
  document.getElementById('root')
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js